<script lang="ts">
  import type { ComparativePrice } from "../../../../../types/CinemaProductsDto.types.ts";

  interface Props {
    comparative: ComparativePrice;
  }

  const { comparative }: Props = $props();

  const prefix: string = "UVP";
</script>

<div>
  {#if comparative.isUvp}
    <span class="prefix">{prefix}</span>
  {/if}
  <span class="price">{comparative.price}</span>
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  div {
    display: inline-flex;
    flex-wrap: nowrap;
  }

  .prefix {
    padding-right: tokens.$oc-semantic-spacing-50;
  }

  .price {
    text-decoration: line-through;
    white-space: nowrap;
  }
</style>
